const seo = [

    // page 1

    {
        id: "blog-1",
        slug: "everyday-tips-for-healthy-gums",
        title: "Everyday Tips for Healthy Gums | Carrum Downs Dental | Dental Blogs",
        description: "Healthy gums help prevent the development of gum disease, which can cause permanent damage. Read our latest blog to learn the best tips for gum care!"
    },{
        id: "blog-2",
        slug: "are-dental-implants-safe-for-your-health",
        title: "Are Dental Implants Safe for your Health? | Dental Blogs",
        description: "Here we will show you the basic information about dental implants. Are there any reasons why you shouldn't use dental implants? Read this blog before you decide!"
    },{
        id: "blog-3",
        slug: "different-types-of-dental-crown",
        title: "Different Types of Dental Crown | Carrum Downs Dental Blogs",
        description: "Dental crowns are permanent caps placed on weak or damaged teeth to protect and cover a tooth. Read this brief guide to help you figure out types of dental crowns."
    },{
        id: "blog-4",
        slug: "how-does-dental-health-affect-your-overall-health",
        title: "How does dental health affect your overall health? | Dental Blog",
        description: "Did you know your dental and gum health affects your general health? The answer is YES. Read this blog to know how oral health can affect your overall health."
    },{
        id: "blog-5",
        slug: "top-5-things-you-need-to-know-about-invisalign",
        title: "Top 5 things you need to know about Invisalign | Dental Blog",
        description: "Are you considering Invisalign treatment to straighten crooked teeth? Here are the top 5 things you need to know before going for Invisalign Treatment."
    },{
        id: "blog-6",
        slug: "types-of-sedation-dentistry-and-how-it-can-help-you",
        title: "Types of Sedation Dentistry and How It Can Help You | Dental Blogs",
        description: "Sedation dentistry allows patients to feel calm and relaxed during their dental treatments. Learn more about the different types of sedation dentistry."
    },{
        id: "blog-7",
        slug: "can-gum-disease-cause-bad-breath",
        title: "Can Gum Disease Cause Bad Breath | Dental Blog | Carrum Downs Dental",
        description: "Cavities and deeper pockets from gum disease give bad breath bacteria extra places to hide in your mouth that are difficult to clear out when you're brushing your teeth."
    },{
        id: "blog-8",
        slug: "learn-how-invisalign-can-correct-your-smile",
        title: "Learn How Invisalign can Correct your Smile | Dental Blog",
        description: "Invisalign is an orthodontic treatment that straightens teeth without the use of metal braces. Read on to Learn how Invisalign can correct your smile."
    },{
        id: "blog-9",
        slug: "how-to-prevent-dry-socket-after-teeth-extraction",
        title: "How to Prevent Dry Socket After Teeth Extraction | Dental Blog",
        description: "A dry socket is the most common tooth extraction complication. Read on to know some of the tips on how to prevent dry sockets after teeth extraction."
    },{
        id: "blog-10",
        slug: "5-best-practices-to-improve-your-dental-health",
        title: "5 Best Practices to Improve Dental Health | Carrum Downs Dental",
        description: "Several problems can affect your oral health, but taking good care can keep your teeth healthy. Check out these five tips to keep your dental health at its best."
    },{
        id: "blog-11",
        slug: "what-to-do-when-a-dental-emergency-happens",
        title: "What To Do When Dental Emergency Happens? Carrum Downs Dental",
        description: "You only have one set of natural teeth, and it is very important to safeguard them at all costs. Read to find out what to do when a dental emergency happens."
    },

    // page 2
    {
        id: "blog-12",
        slug: "tips-to-prepare-for-your-root-canal-treatment",
        title: "Tips for Your Root Canal Treatment | Carrum Downs Dental Blog",
        description: "Are you afraid that you will experience pain during root canal therapy? Here are some of the things you need to do in preparation for root canal therapy."
    }, {
        id: "blog-13",
        slug: "carrum-downs-dental-group-government-schemes",
        title: "Carrum Downs Dental Group Government Schemes | Dental Blog",
        description: "Carrum Downs Dental Group supports a number of government schemes and provide patients with dental treatment eligible under these schemes. Visit our website to know more."
    }, {
        id: "blog-14",
        slug: "11-ways-to-keep-your-teeth-and-gum-healthy",
        title: "11 Ways To Keep Your Teeth and Gum Healthy | Carrum Downs Dental",
        description: "Brushing your teeth everyday alone does not equate to oral health. Know how you can keep your teeth and gums healthy to maintain good oral health."
    }, {
        id: "blog-15",
        slug: "fluoride-treatment-benefits-and-side-effects",
        title: "Fluoride Treatment: Benefits and Side Effects | Carrum Downs Dental",
        description: "Fluoride is a naturally occurring mineral that helps in building stronger teeth and bones. Learn about the treatment, benefits and side effects of fluoride."
    }, {
        id: "blog-16",
        slug: "ways-to-fix-your-broken-and-chipped-tooth",
        title: "Ways to Fix Your Broken and Chipped Tooth | Carrum Downs Dental",
        description: "A tooth can be chipped or broken due to trauma from an accident or vigorous activities such as sports or playing. Learn the ways to fix your broken teeth."
    }, {
        id: "blog-17",
        slug: "dead-tooth-signs-symptoms-and-treatment",
        title: "Dead Tooth: Signs, Symptoms, and Treatment | Carrum Downs Dental",
        description: "A tooth is considered dead if the nerve and pulp no longer receive any blood flow. Learn about the symptoms, signs & treatment of a dead tooth."
    }, {
        id: "blog-18",
        slug: "20-facts-about-dentures-thatll-knock-your-socks-off",
        title: "20 Facts about Dentures That'll Knock Your Socks Off",
        description: "Dentures are a common tooth replacement option for people who have lost most of their teeth. Learn about the 20 facts about dentures."
    }, {
        id: "blog-19",
        slug: "teeth-whitening-expectations-vs-reality",
        title: "Teeth Whitening: Expectations vs. Reality | Carrum Downs Dental",
        description: "Teeth whitening is a common cosmetic dentistry procedure, and that is why it comes with a lot of misinformation. Learn about the expectations and reality about it."
    }, {
        id: "blog-20",
        slug: "things-you-may-not-know-about-bulk-bill-dentist",
        title: "Things You May Not Know About Bulk Bill Dentist | Dental Blog",
        description: "Wondering about what bulk billing is and what a bulk bill dentist does? Here are some things you may not know about a bulk billing dentist."
    }, {
        id: "blog-21",
        slug: "types-of-tooth-fillings-and-how-to-choose-the-best-for-your-teeth",
        title: "5 Types Of Tooth Fillings: Know Which One is Best For Your Teeth ",
        description: "Tooth fillings are dental material that is used to fill up a cavity on a tooth to restore their functionality. Learn about the various types of tooth fillings."
    }, {
        id: "blog-22",
        slug: "what-to-expect-while-visiting-the-teeth-cleaning-dentist",
        title: "What To Expect While Visiting The Dentist For Teeth Cleaning?",
        description: "Visiting the dentist for professional teeth cleaning is a vital part of your oral hygiene practice. Takes a look at what to expect while visiting the dentist."
    }, {
        id: "blog-23",
        slug: "best-mouthwash-for-bad-breath",
        title: "Best Mouthwash for Bad Breath | Carrum Downs Dental Group",
        description: "Choose a therapeutic mouthwash if your main concern is to fight the germs and bacteria that cause bad breath. Check out the best mouthwash to get rid of bad breath."
    },

    // page 3

    {
        id: "blog-24",
        slug: "5-key-benefits-of-laser-dental-surgery",
        title: "5 Key Benefits of Laser Dental Surgery | Carrum Downs Dental",
        description: "Laser dentistry has been improved and enhanced to handle more difficult oral issues. Read on to learn on the five key benefits of laser dental surgery."
    }, {
        id: "blog-25",
        slug: "best-ways-to-protect-your-teeth-during-this-covid-19",
        title: "Best Ways to Protect Your Teeth During this COVID-19 Pandemic",
        description: "Due to restricted movements, it is becoming difficult to get dental care during Covid. Try these best measures to help keep your teeth healthy during Covid-19."
    }, {
        id: "blog-26",
        slug: "laughing-gas-in-dentistry",
        title: "Sedation Dentistry with Laughing Gas | Carrum Downs Dental Group",
        description: "Laughing Gas in dentistry has an additional benefits. It has become one of the most preferred anaesthetics of choice for most dentists and patients alike."
    }, {
        id: "blog-27",
        slug: "how-to-relieve-tooth-pain-from-sinus-pressure",
        title: "How to Relieve Tooth Pain from Sinus Pressure? | Carrum Downs Dental",
        description: "Sinus pressure occurs when the sinus cavities become inflamed and swell, causing pressure on the upper teeth beneath the nasal canal. Read more on how to get relief."
    }, {
        id: "blog-28",
        slug: "4-diet-tips-for-healthy-teeth-at-home",
        title: "4 Diet Tips for Healthy Teeth at Home | Carrum Downs Dental Blog",
        description: "We try to keep our teeth as healthy as possible by following oral care tips but these activities might not be enough to keep the cavity and decay at bay. Learn more."
    }, {
        id: "blog-29",
        slug: "dental-bonding-for-gaps-in-teeth",
        title: "Dental Bonding for Gaps in Teeth | Carrum Downs Dental Blog",
        description: "Most of the people who have gaps in their teeth feel uncomfortable when smiling and want to get rid of it. Dental bonding is the best option for this problem."
    }, {
        id: "blog-30",
        slug: "replacing-teeth-lost-through-gum-disease",
        title: "Replacing Teeth Lost Through Gum Disease | Carrum Downs Dental",
        description: "Wondering how you can replace a tooth lost through gum disease? Read on to find out the best teeth replacement options for teeth lost through gum disease."
    }, {
        id: "blog-31",
        slug: "is-ultrasonic-teeth-cleaning-safe",
        title: "Is ultrasonic teeth cleaning safe? | Carrum Downs Dental Group",
        description: "To find out if ultrasonic teeth cleaning is safe, you need to know the pros and cons so you can decide whether it is safe for you or not. Check out the pros and cons"
    }, {
        id: "blog-32",
        slug: "getting-a-tooth-pulled-what-to-expect-during-and-after-tooth-extraction",
        title: "Getting A Tooth Pulled – What to expect during & after extraction?",
        description: "Tooth extraction is one of the most common dental procedures. Read on to find out what happens during tooth extraction and what to expect after the procedure."
    }, {
        id: "blog-33",
        slug: "can-i-have-orthodontic-treatment-if-i-have-a-root-canal-in-my-tooth",
        title: "Can I Have Orthodontic Treatment After a Root Canal in My Tooth?",
        description: "Placing braces on teeth that have had work done can be complicated and challenging. It is important to seek the advice of a specialist before getting braces."
    }, {
        id: "blog-34",
        slug: "treatment-to-deal-with-dental-nerve-damage",
        title: "Treatment to Deal with Dental Nerve Damage | Carrum Downs Dental",
        description: "Depending on the cause of injury, there are various treatments that may be applied to treat dental nerve damage. Learn about the treatment of dental nerve damage."
    }, {
        id: "blog-35",
        slug: "teeth-whitening-facts-and-myths",
        title: "Teeth Whitening Facts and Myths | Carrum Downs Dental Group",
        description: "Teeth whitening is a process that clean your teeth and gives them a pearly appearance. Learn how these myths and facts affect the treatment procedure as a whole."
    },

    // page 4

    {
        id: "blog-36",
        slug: "the-connection-between-sinus-infection-and-tooth-pain",
        title: "Know The Relationship between Sinus Infection and Tooth Pain",
        description: "So what is the relationship between a sinus infection and tooth pain? Why does it cause tooth pain? Read more to know everything about sinus infection and tooth pain."
    }, {
        id: "blog-37",
        slug: "delaying-wisdom-tooth-extraction-can-lead-to",
        title: "Delaying Wisdom Tooth Extraction Can Lead To | Dental Blog",
        description: "Many people have this question, is it really necessary to have wisdom teeth removed? Read the article to learn, what delaying a wisdom tooth extraction can lead to."
    }, {
        id: "blog-38",
        slug: "how-dentist-treat-the-longitudinal-tooth-cracks-and-fracture-issues",
        title: "How Dentist Treat the Longitudinal Tooth Cracks and Fracture Issues",
        description: "A longitudinal tooth fracture is a fracture that occurs along the vertical lines of a tooth from the crown towards the root or vice versa. Learn more."
    }, {
        id: "blog-39",
        slug: "do-you-need-emergency-dental-care",
        title: "Do You Need Emergency Dental Care? | Carrum Downs Dental Group",
        description: "It is always essential to know what types of dental injuries require emergency dental care to ensure that you and your loved one's teeth are well taken care."
    }, {
        id: "blog-40",
        slug: "what-to-do-with-decayed-wisdom-tooth",
        title: "What To Do with Decayed Wisdom Tooth? Carrum Downs Dental Group",
        description: "Just like any other tooth decay, wisdom teeth need prompt treatment before they get worse & cause other complicated problems. Learn more about wisdom tooth decay."
    }, {
        id: "blog-41",
        slug: "do-cavities-cause-bad-breath-causes-and-treatment",
        title: "Do Cavities Cause Bad Breath? Know The Causes and Treatment",
        description: "Bad breath can be caused by cavities, tonsil stones, and poor oral hygiene. If you experience bad breath visit your dentist to check for cavities."
    }, {
        id: "blog-42",
        slug: "bulimias-effect-on-teeth",
        title: "Bulimia’s Effect on Teeth | Carrum Downs Dental Group",
        description: "Bulimia is a psychological & physical disease which involves discrete periods of binge eating that may happen several times a week. Learn effects of bulimia on teeth"
    }, {
        id: "blog-43",
        slug: "how-to-overcome-the-fear-of-visiting-a-dentist",
        title: "How to Overcome the Fear of Visiting a Dentist? | Carrum Downs Dental",
        description: "A majority of us do not like visiting the dentist is due to fear. Here are some tips to help you overcome the fear of visiting the dentist."
    }, {
        id: "blog-44",
        slug: "telehealth-carrum-downs-dental-clinic",
        title: "What is Telehealth? | Telehealth Service by Carrum Downs Dental Group",
        description: "Telehealth is the delivery of different health care services through an interactive, live video conferencing. We now offer Telehealth consultation. Reach us today!"
    }, {
        id: "blog-45",
        slug: "know-everything-about-removable-partial-dentures",
        title: "Everything You Need To Know About Removable Partial Dentures",
        description: "Losing a tooth or a couple of teeth can impact on your overall aesthetic. Know about the removable partial dentures & how it can help you with the problem."
    }, {
        id: "blog-46",
        slug: "trends-in-youth-that-can-lead-to-oral-health-complications",
        title: "Trends in Youth that Can Lead to Oral Health Complications | Blog",
        description: "There are many trends among the youths that come and go. Takes a look at some trends in youths that can lead to dental complications. Read more."
    }, {
        id: "blog-47",
        slug: "important-notice-on-covid-19-coronavirus",
        title: "Important Notice on COVID-19 (Coronavirus) | Carrum Downs Dental",
        description: "During this pandemic, if you experience a dental emergency and seeking the support of a dentist; Book an appointment at the Carrum Downs Dental."
    },

    // page 5

    {
        id: "blog-48",
        slug: "causes-of-gum-bleeding-and-its-treatment",
        title: "Causes of Gum Bleeding and its Treatment | Carrum Downs Dental",
        description: "If you are experiencing blood in your gums than you are in a stage of developing gum disease. Check out the causes of gum diseases and take good care of yourself."
    }, {
        id: "blog-49",
        slug: "problem-with-partial-dentures-and-their-solution",
        title: "Problem with Partial Dentures and their Solution | Carrum Downs Dental",
        description: "Partial dentures are designed by your dentist to fit the empty teeth space after examining your mouth. However, dentures tend to come with a number of issues."
    }, {
        id: "blog-50",
        slug: "the-ultimate-invisalign-true-or-false-test",
        title: "The Ultimate Invisalign True or False Test - Infographics",
        description: "Adults love Invisalign as they are invisible and removable, they can be great for teenagers too! Read the Infographics to unveil the true/false test of Invisalign"
    }, {
        id: "blog-51",
        slug: "blog",
        title: "Blog | Carrum Downs Dental Group | Dentist Carrum Downs",
        description: "Our blog contains various posts related to the dental conditions, treatments and vouchers. Read our blogs for dental tips and be aware of the dental problems."
    }, {
        id: "blog-52",
        slug: "study-says-wine-kills-germs-that-cause-sore-throats-and-dental-plaque",
        title: "Wine Kills Germs that cause Sore Throats and Dental Plaque",
        description: "Recent studies show that there is an effective antimicrobial agent found in both white and red wine that affects the growth of bacteria. Learn more."
    }, {
        id: "blog-53",
        slug: "5-ways-to-make-your-teeth-golden-globe-ready",
        title: "5 Ways To Make Your Teeth Pearly White | Carrum Downs Dental Group",
        description: "Browse through the Infographics to learn the different ways of getting a golden globe smile. Check out this amazing Infographics."
    }, {
        id: "blog-54",
        slug: "periodontitis-why-we-need-a-vaccine-for-gum-disease",
        title: "Periodontal Disease: Why We Need a Vaccine for Gum Disease?",
        description: "Periodontitis is a severe gum infection caused by the accumulation of bacteria on your gums and teeth. Know why we need a vaccine for a gum disease."
    }, {
        id: "blog-55",
        slug: "what-is-gingivitis-its-symptoms-causes-and-treatment",
        title: "What Is Gingivitis? Know Its Symptoms, Causes, and Treatment",
        description: "Gingivitis is the swelling of the gums as a result of an infection caused by plaque build-up on the teeth and around the gums. Know the symptoms, causes and treatment"
    }, {
        id: "blog-56",
        slug: "night-guards-for-teeth-clenching-and-their-types",
        title: "Night Guards for Teeth Clenching and Their Types | Carrum Downs Dental",
        description: "Night guards are plastic mouthpieces that are designed to fit your teeth and jaw naturally. Here are the three different types of night guards for teeth clenching."
    }, {
        id: "blog-57",
        slug: "calming-your-nerves-before-going-to-the-dentist",
        title: "Calming Your Nerves before Going to the Dentist | Carrum Downs Dental",
        description: "Dental phobia is a serious condition that can leave you terrified & panic-stricken. Read on to know tips on keeping your nerves calm before visiting the dentist?"
    }, {
        id: "blog-58",
        slug: "let-a-cosmetic-dentist-improve-your-smile",
        title: "How Can A Cosmetic Dentist Improve Your Smile? Infographics",
        description: "Check out the ways in which a cosmetic dentist can help you to improve your smile. Learn more about it from this dental Infographics."
    }, {
        id: "blog-59",
        slug: "veneers-vs-clear-aligners-choose-the-correct-one",
        title: "Veneers vs. Clear Aligners – Choose The Right One For Your Smile",
        description: "Both Invisalign, as well as veneers, can help improve the appearance of your smile. Check out which amongst the 2 could make the right choice for your smile."
    },

    // page 6

    {
        id: "blog-60",
        slug: "teeth-whitening-questions-you-might-be-having",
        title: "Questions You Might Be Having About Teeth Whitening | Blog",
        description: "We have compiled some of the frequently asked questions that we get from our patients to help you to learn more about teeth whitening. Click to read more"
    }, {
        id: "blog-61",
        slug: "do-genetic-factors-influence-oral-health",
        title: "Do Genetic Factors Influence Oral Health? | Carrum Downs Dental Group",
        description: "It is important to know that there are genetic factors beyond your control that affect your gums and teeth. Learn more about how they affect the teeth."
    }, {
        id: "blog-62",
        slug: "is-it-possible-to-straighten-your-teeth-without-braces",
        title: "Is It Possible to Straighten Your Teeth Without Braces? | Blog",
        description: "Ashamed of misaligned teeth and wondering how you can get a straight and a perfect smile without having to get braces fitted? Learn some of the options here."
    }, {
        id: "blog-63",
        slug: "the-most-common-dental-issues-experienced-by-seniors-today",
        title: "The Most Common Dental Issues Experienced by Seniors Today | CDD",
        description: "Looking out of your elder one’s teeth is as crucial as their digestive health & heart. Here’re the dental issues experienced by seniors that you need to look out."
    }, {
        id: "blog-64",
        slug: "12-alarming-signs-that-indicate-you-need-to-visit-the-dentist-immediately",
        title: "12 Alarming Signs You Need to Visit the Dentist Immediately",
        description: "Before you keep ignoring your mouth, here are 12 alarming signs that indicate you need to visit the dentist immediately. Read more."
    }, {
        id: "blog-65",
        slug: "know-about-severe-problems-with-your-teeth-and-gums",
        title: "Know About Severe Dental Problems with Your Teeth and Gums",
        description: "Oral health is a vital part of your well-being and overall health. Poor oral hygiene can lead to numerous problems like gum diseases, oral cancer, etc. Learn More."
    }, {
        id: "blog-66",
        slug: "7-things-to-consider-when-choosing-a-dentist",
        title: "7 Things to Consider When Choosing a Dentist | Carrum Downs Dental",
        description: "It is crucial to choose a trustworthy dentist. Therefore, it’s important you take your time and find a qualified dentist. Here’re 7 factors to look for in a dentist."
    }, {
        id: "blog-67",
        slug: "dental-injuries-how-to-handle-dental-injuries",
        title: "Dental Injuries - How to Handle Dental Emergency | Infographics",
        description: "Check out the dental first aid tips for baby teeth and adult teeth. Read more to know how to handle such type of dental emergency."
    }, {
        id: "blog-68",
        slug: "malocclusion-causes-and-treatment",
        title: "Malocclusion of Teeth – Causes and Treatment | Carrum Downs Dental",
        description: "Malocclusion is derived from the term occlusion, which is a dental term referring to the misalignment problem of the teeth. Know the causes & treatment."
    }, {
        id: "blog-69",
        slug: "dental-abscess-know-the-symptom-cause-and-treatment",
        title: "Dental Abscess - Know the Symptom, Cause and Treatment",
        description: "A dental abscess is a collection of pus located in the tooth roots and/or gums. Read on to find out more about dental abscess- its symptoms, cause and treatment."
    }, {
        id: "blog-70",
        slug: "tooth-enamel-erosion-causes-prevention-and-treatment",
        title: "Tooth Enamel Erosion - Causes, Prevention and Treatment",
        description: "Tooth enamel is the outer layer of your teeth that can get eroded due to many things. Know the causes, prevention & treatment for tooth enamel erosion."
    }, {
        id: "blog-71",
        slug: "surprising-things-your-tongue-can-tell-you-about-your-health",
        title: "Surprising Secrets Your Tongue Can Tell You About Your Health",
        description: "Your tongue can reveal a lot of surprising secrets about your health. Want to know more about those surprising secrets? Check out this article."
    },

    //page 7

    {
        id: "blog-72",
        slug: "top-10-dental-problems-and-their-treatments",
        title: "Top 10 Dental Problems and Their Best Treatments | Infographics",
        description: "Get to know the top 10 dental problems by browsing this Infographics. For every problem there is the best treatment options available."
    },{
        id: "blog-73",
        slug: "know-the-wisdom-teeth-removal-procedure-and-complications",
        title: "Know The Wisdom Teeth Removal Procedure and Complications | Blog",
        description: "Take a look at the procedure of wisdom teeth removal as well as the possible complications that may occur after the extraction of wisdom teeth."
    },{
        id: "blog-74",
        slug: "why-teeth-experience-throbbing-pain-and-sensitivity-after-a-dental-filling",
        title: "Experiencing Throbbing Pain and Sensitivity After a Dental Filling",
        description: "Learn the reason why one experiences throbbing pain and sensitivity after dental filling and how to deal with the issue."
    },{
        id: "blog-75",
        slug: "why-dental-scaling-and-root-planing-is-necessary",
        title: "Why Dental Scaling & Root Planing is Necessary? | Carrum Downs Dental",
        description: "Proper oral hygiene is not enough to prevent dental calculus buildup below the gum line so, scaling and root planing is necessary for removal of calculus and plaque."
    },{
        id: "blog-76",
        slug: "understanding-the-stages-of-tooth-decay",
        title: "Understanding the Stages of Tooth Decay | Carrum Downs Dental",
        description: "Tooth decay is a common problem that people usually face. Learn about the different stages of tooth decay and what happens in every stage."
    },{
        id: "blog-77",
        slug: "benefits-of-invisible-braces-dental-infographics",
        title: "Benefits of Invisible Braces - Dental Infographics",
        description: "Clear aligners are the transparent strong braces material in the form of dental braces. Read the benefits of Invisible Braces represented in this Infographic."
    },{
        id: "blog-78",
        slug: "why-dental-crown-is-necessary-after-root-canal",
        title: "Why Dental Crown is Necessary after Root Canal? | Carrum Downs Dental",
        description: "Root canal is one of the most effective treatments for an infected or injured tooth. Know why dentists recommend a dental crown after the root canal treatment."
    },{
        id: "blog-79",
        slug: "reasons-why-dentures-are-preferred-by-many-dentists",
        title: "Five Reasons Why Dentures Are Preferred By Many Dentists",
        description: "Dentures are among the best tooth restoration appliances preferred by many dentists. Here are some of the reasons why most dentists prefer dentures."
    },{
        id: "blog-80",
        slug: "natural-ways-to-whiten-your-teeth-at-home",
        title: "Natural Ways to Whiten Your Teeth At Home | Carrum Downs Dental",
        description: "Embarrassed of your stain teeth? Here we present you some natural ways using which you can gain whiter, brighter, pearly smile. Check it out!"
    },{
        id: "blog-81",
        slug: "dental-practice-to-save-childrens-teeth-from-cavities",
        title: "Dental Practice To Save Children’s Teeth From Cavities | Blog",
        description: "Dental cavities can steal child’s ability to eat & sleep. It’s our responsibility to keep our children’s teeth free from cavities. Follow these dental care tips."
    },{
        id: "blog-82",
        slug: "5-reasons-why-a-dental-implant-can-save-your-tooth",
        title: "5 Reasons Why A Dental Implant Can Save Your Tooth | Infographic",
        description: "Check out the Infographics to learn the reasons how dental implant can save your tooth from dental problems."
    },{
        id: "blog-83",
        slug: "facts-and-myths-of-root-canal-treatment",
        title: "Facts and Myths of Root Canal Treatment | Carrum Downs Dental",
        description: "Let us dispel the facts and myths about the root canal to help you find out whether it is reasonable for you to fear this treatment option. Read more."
    },
    
    // page 8

    {
        id: "blog-84",
        slug: "common-type-of-dental-injuries-occurring-in-sports",
        title: "Common Type of Dental Injuries Occurring in Sports",
        description: "Dental injury is a risk in almost all types of sports. Here are some of the most common dental injuries occurring in sports. Read more in detail."
    },{
        id: "blog-85",
        slug: "dangers-and-side-effects-of-root-canal-treatment",
        title: "Dangers and Side Effects of Root Canal Treatment | Carrum Downs Dental",
        description: "Root Canal has been known to cause many serious diseases if the tooth gets infected. Here we explain four probable dangers and side effects of the root canal."
    },{
        id: "blog-86",
        slug: "7-tips-for-improving-your-oral-health-before-sleep-time",
        title: "7 Tips for Improving Your Oral Health Before Sleep Time | Blog",
        description: "It is vital to take proper oral hygiene measures before you sleep. Adapt these seven proven ways to keep your mouth free from bacteria while asleep."
    },{
        id: "blog-87",
        slug: "what-is-the-difference-between-dental-sealants-and-dental-fillings",
        title: "Difference Between Dental Sealants and Dental Fillings? | Blog",
        description: "Sealants & dental fillings are the two dental terms that can be quite confusing. They are different in numerous ways, such as their permanence, materials, & purpose."
    },{
        id: "blog-88",
        slug: "why-is-clear-aligners-the-best-choice-how-to-clean-clearcorrect-aligners",
        title: "Why is Clear Aligners The Best Choice? How To Clean Clear Aligners?",
        description: "Clear Aligners are the most recent, and modest technique to straighten teeth. Here are more reasons why you may wish to choose clear aligners."
    },{
        id: "blog-89",
        slug: "faqs-on-dental-insurance-and-dental-plans",
        title: "FAQs On Dental Insurance And Dental Plans | Carrum Downs Dental Group",
        description: "Here are some frequently asked questions about dental insurance and dental plans. We have got answers for this questions too. Read more."
    },{
        id: "blog-90",
        slug: "5-reasons-why-it-is-important-to-have-a-family-dentist",
        title: "Know The Importance of Having A Family Dentist | Dental Blog",
        description: "If you are tired of visiting different dentists to accommodate the different oral needs of your family, it is high time you switch to a family dentist. Read more."
    },{
        id: "blog-91",
        slug: "why-regular-dental-care-save-you-big-later",
        title: "Why Regular Dental Care Save You Big Later – Infographics",
        description: "Check out this infographic to know how regular dental care can now save you from a big problem later."
    },{
        id: "blog-92",
        slug: "blog",
        title: "Blog | Carrum Downs Dental Group | Dentist Carrum Downs",
        description: "Our blog contains various posts related to the dental conditions, treatments and vouchers. Read our blogs for dental tips and be aware of the dental problems."
    },{
        id: "blog-93",
        slug: "what-are-some-of-the-dental-problems-which-need-surger",
        title: "What Are Some Of The Dental Problems Which Need Surgery? | Blog",
        description: "A majority of people think that oral surgery only includes dental procedures meant to fix the gums and teeth. However, it goes far beyond that. Learn more."
    },{
        id: "blog-94",
        slug: "make-your-own-emergency-dental-kit-with-this-checklist",
        title: "Make Your Own Dental Emergency Kit with This Checklist | Blog",
        description: "Having a dental first aid kit can help in case of a minor dental injury, thus keeping you protected until you are able to visit the dental office. Checkout the list!"
    },{
        id: "blog-95",
        slug: "a-few-things-to-know-about-fluoride-treatment",
        title: "A Few Things to Know About Fluoride Treatment | Carrum Downs Dental",
        description: "Fluoride treatments can help in treating several conditions caused by a fluoride deficiency. Which begs the question, are fluoride treatments safest?"
    },

    // page 9

    {
        id: "blog-96",
        slug: "how-to-choose-a-great-dental-practice",
        title: "How To Choose A Great Dental Practice | Infographics",
        description: "If you don't know how to choose a great dental practice then view this infographics, it will help you to find a good dentist and dental practice."
    },{
        id: "blog-97",
        slug: "smoking-how-does-it-destroy-your-oral-health",
        title: "How Does Smoking Destroy Your Oral Health? | Infographics",
        description: "Smoking is very dangerous vice, it not only destroys your general health but affects your oral health. Here are the risks that smoking can do to your oral wellbeing."
    },{
        id: "blog-98",
        slug: "how-to-fix-crooked-teeth-and-get-an-adorable-smile",
        title: "How to Fix Crooked Teeth and Get an Adorable Smile | Dental Blog",
        description: "Tired of covering your crooked teeth? There is a lot you can do to correct them with the help of a dentist. Check out the options to fix your crooked teeth."
    },{
        id: "blog-99",
        slug: "dental-care-ideas-to-prevent-tooth-decay",
        title: "DIY: Dental Care Ideas to Prevent Tooth Decay | Carrum Downs Dental",
        description: "Tooth decay also known as dental cavities or caries, is one of the most common oral ailments. Here are some imp steps to reduce your risks of getting tooth decay."
    },{
        id: "blog-100",
        slug: "why-smoking-should-be-avoided-after-wisdom-teeth-extraction",
        title: "Why You Should Avoid Smoking After Wisdom Teeth Extraction?",
        description: "Smoking can lead to numerous oral complications that's why it is important to avoid smoking for at least a week or two after having your wisdom tooth extracted."
    },{
        id: "blog-101",
        slug: "things-you-should-know-about-invisible-braces",
        title: "Clear Aligners- Things You Should Know Before Getting Invisible Braces",
        description: "Misaligned or crooked teeth not only look unattractive but also make cleaning to be a challenge. Here are some reasons to choose clear aligners over metal braces."
    },{
        id: "blog-102",
        slug: "is-there-is-correlation-between-poor-health-and-diabetes",
        title: "Correlation Between Poor Oral Health & Diabetes | Infographic",
        description: "Check out this infographic that shows the correlation between poor oral health & diabetes. Discover dental tips to prevent dental problems related to diabetes."
    },{
        id: "blog-103",
        slug: "can-dental-problems-cause-headache-and-eye-pain",
        title: "Can Dental Problems Cause Headache and Eye Pain? | Carrum Downs Dental",
        description: "If you have been getting a constant headache and eye pain, the culprit could be related to one of your dental problems. Learn more about it in detail."
    },{
        id: "blog-104",
        slug: "fall-for-the-food-that-are-good-for-your-dental-health",
        title: "Fall For The Food That Are Good For Your Dental Health | Blog",
        description: "The food you eat can help in strengthening your teeth or can damage your teeth, so make sure to fall for the foods that promote your dental health. Read more."
    },{
        id: "blog-105",
        slug: "surprising-reasons-why-straight-teeth-matters",
        title: "Surprising Reasons Why Straight Teeth Matters | Carrum Downs Dental",
        description: "Your smile is midst the first things people notice when you meet them. Here are some of the surprising reasons why straight teeth matters. Read more."
    },{
        id: "blog-106",
        slug: "how-to-choose-the-right-toothpaste",
        title: "Dental Tips: How To Choose The Right Toothpaste?",
        description: "It is important to know the factors one should look out to choose the right toothpaste. Read out some tips on how to choose the right toothpaste."
    },{
        id: "blog-107",
        slug: "give-your-teeth-a-fighting-chance",
        title: "Give Your Teeth a Fighting Chance | Infographics",
        description: "Steer clear of these dental enemies and keep your teeth healthy and strong. Have a look at this dental infographics to be aware of the dental emergencies."
    },

    // page 10

    {
        id: "blog-108",
        slug: "how-sugar-is-harming-your-children",
        title: "How Sugar Is Harming Your Child’s Dental Health | Infographics",
        description: "Here is the survey on how sugar is harming your child’s dental health. Have a look at what can be done to prevent your kid’s dental health. Check out in detail."
    }, {
        id: "blog-109",
        slug: "dental-implant",
        title: "Dental Implants - Some Facts And Procedure | Infographics",
        description: "Dental implant is the effective option for missing tooth. Here are some facts about dental implants & complete procedure, how the surgery is performed. Have a look."
    }, {
        id: "blog-110",
        slug: "get-the-whiter-brighter-smile-with-pola-whitening",
        title: "Get The Whiter Brighter Smile with Pola Teeth Whitening",
        description: "Get rid of your stained teeth with the pola whitening. Pola whitening is one of the latest teeth whitening procedures that can help you achieve a brighter smile."
    }, {
        id: "blog-111",
        slug: "effective-treatment-for-your-gummy-smile",
        title: "Effective Treatment For Your Gummy Smile | Carrum Downs Dental",
        description: "Gummy smile is referred as an excessive gingival display, i.e. when you smile, too much gum tissues appear above your upper teeth. Here is the effective treatment."
    }, {
        id: "blog-112",
        slug: "tips-to-get-fresh-breath-by-this-valentines-day",
        title: "Tips To Follow: Get Fresh Breath By This Valentine’s Day",
        description: "February is here, & that means only one thing- Valentine’s Day around the corner! Be ready with your fresh breath to reach out your special someone. Follow the tips."
    }, {
        id: "blog-113",
        slug: "how-to-make-brushing-fun-for-your-child",
        title: "Dental Tips: How To Make Brushing A Fun Experience For Your Child",
        description: "Follow these tips to make brushing fun for your child, apart from school activities they still have to learn to take care of their bodies in new ways each day."
    }, {
        id: "blog-114",
        slug: "enamel-damage-and-tooth-decay",
        title: "Enamel Damage And Tooth Decay - Risk Of Sports Drinks",
        description: "Most popular sports drinks contain potential factors that may damage the teeth. So, if you're into drinking sports drinks, here's what you should do to prevent it."
    }, {
        id: "blog-115",
        slug: "life-of-dead-tooth",
        title: "Dead Tooth - Causes, Symptoms, Treatment | Infographics",
        description: "Do you know why does a tooth die? How will you come to know that your tooth is no longer alive? Here's the answer to these questions and the treatment too."
    }, {
        id: "blog-116",
        slug: "dental-crown-purpose-procedure-and-more",
        title: "Dental Crown - Purpose, Types, Procedure | Carrum Downs Dental",
        description: "Get to know the purpose of dental crowns, their various types and the procedure. Check the aftercare and be aware of the complications. Read more."
    }, {
        id: "blog-117",
        slug: "services-offered-by-the-family-dentists",
        title: "Dental Services Offered By The Family Dentist | Carrum Downs Dental",
        description: "Learn about the different services offered by the family dentist, which include preventative dental service, restorative dental service, cosmetic dental service etc."
    }, {
        id: "blog-118",
        slug: "dental-health-tips-during-pregnancy",
        title: "Dental Health Care Tips For Pregnant Women | Carrum Downs Dental",
        description: "During pregnancy, women experience numerous body changes, this includes changes in the oral cavity which affect their oral health. Follow these tips for prevention."
    }, {
        id: "blog-119",
        slug: "benefits-of-cloves-for-toothaches",
        title: "Different Ways To Use Cloves For Toothaches | Carrum Downs Dental",
        description: "Cloves contain a strong anaesthetic known as eugenol which similarly works as an antiseptic to fight bacteria. Here are different ways to use cloves for toothaches."
    },

    // page 11

    {
        id: "blog-120",
        slug: "what-are-the-causes-of-sensitive-teeth-how-to-prevent-it",
        title: "Sensitive Teeth – Causes, Prevention | Carrum Downs Dental",
        description: "Learn about the causes of teeth sensitivity and how we can prevent our teeth from getting sensitive by adapting some good habits like avoiding teeth grinding, etc."
    }, {
        id: "blog-121",
        slug: "tips-to-keep-good-dental-hygiene-as-you-get-older",
        title: "5 Tips To Keep Good Dental Hygiene As You Get Older | Dental Blog",
        description: "As you get older your teeth need more attention and care, so here are some dental tips you should adapt to keep your smile healthy in your old age also. Read more."
    }, {
        id: "blog-122",
        slug: "what-are-the-ways-to-avoid-dental-emergencies",
        title: "Ways To Avoid Dental Emergency | Carrum Downs Dental",
        description: "Dental emergency may occur at any time, so learn about the various types of dental emergencies and the different ways for avoiding it. Read more in detail & be aware."
    }, {
        id: "blog-123",
        slug: "how-to-restore-a-tooth-after-root-canal-treatment",
        title: "Recovery After A Root Canal Treatment | Carrum Downs Dental",
        description: "Here are some tips on how to recover your tooth from the root canal treatment. A complete guide is provided on root canal which contains the symptoms, recovery etc."
    }, {
        id: "blog-124",
        slug: "how-to-get-rid-of-toothache",
        title: "How To Get Rid Of Toothache | Carrum Downs Dental",
        description: "Toothache may occur due to many reasons such as tooth decay, impacted tooth etc. Here are some tips on how you can manage the pain, read more to know in detail."
    }, {
        id: "blog-125",
        slug: "my-smile-payment-plan",
        title: "My Smile Payment Plan For Dental Treatment",
        description: "Carrum Downs Dental Group offers My Smile Plan to their patients. It is an interest free dental payment plan which allows the patients to go ahead with their dental treatment."
    }, {
        id: "blog-126",
        slug: "dental-implants-offer",
        title: "Dental Implant - Anatomy And Benefits",
        description: "Dental implants offer the feel, function and appearance of original teeth. Know the anatomy and benefits of dental implant. Get your missing tooth replaced now."
    }, {
        id: "blog-127",
        slug: "all-about-wisdom-teeth",
        title: "Wisdom Teeth - Complete Overview And Facts",
        description: "Do you know about the molars which erupt at the back of your mouth? Here is the complete overview of wisdom teeth and it's facts of which we were unaware."
    }, {
        id: "blog-128",
        slug: "an-overview-of-dental-bridges-benefits",
        title: "A Complete Overview Of Dental Bridges",
        description: "Here is the complete guide on the dental bridges. Get to know the types, benefits, procedures etc. Use these guidelines to know the benefits of dental bridges."
    }, {
        id: "blog-129",
        slug: "impacted-wisdom-teeth-extraction",
        title: "Impacted Wisdom Teeth Extraction - Symptoms, Treatment",
        description: "Impacted teeth are those teeth which get stuck inside the gum. Learn about the impacted wisdom teeth symptoms, treatment and how to recover after the extraction."
    }, {
        id: "blog-130",
        slug: "the-complete-guideline-for-dentures",
        title: "The Complete Guidelines For Dentures",
        description: "Complete denture manual - Learn everything about dentures, what are they, who needs a denture, how denture is prepared, how to take care of denture etc."
    }, {
        id: "blog-131",
        slug: "top-10-reasons-for-tooth-pain",
        title: "Top 10 Reasons For Tooth Pain - Carrum Downs Dental Group",
        description: "Toothaches are miserable, it may cause due to many problems. Know the reasons why tooth pain occurs and avoid making those mistakes. Keep your teeth safe for a better future."
    }, 

    // page 12

    {
        id: "blog-132",
        slug: "veneers-crowns-bridges",
        title: "Veneers, Crowns, Bridges - Know The Difference",
        description: "Do you know the difference between veneers, crowns and bridges? Here you'll get to know the difference between each of them, the types and the procedure."
    }, {
        id: "blog-133",
        slug: "which-one-is-right-for-you",
        title: "Know What Is Best For You - Dental Implant Or Dentures",
        description: "For missing tooth, you may take dental implant treatment or dentures treatment, but only a dental professional can tell you for which treatment you are eligible."
    }, {
        id: "blog-134",
        slug: "teeth-whitening-faqs",
        title: "Teeth Whitening FAQs - Carrum Downs Dental",
        description: "Everyone wishes to have a whiter and brighter smile, to get one or more shade up people think about teeth whitening treatment. Here are some faqs you need to know."
    }, {
        id: "blog-135",
        slug: "dental-x-rays",
        title: "All About Dental X-Rays - Carrum Downs Dental",
        description: "Learn everything about the Dental X-Rays - what they are, how it works, what x-rays can detect and some facts about it. Continue Reading..."
    }, {
        id: "blog-136",
        slug: "what-is-better-professional-or-at-home-teeth-whitening",
        title: "What Is Better - Professional vs Home Teeth Whitening",
        description: "Healthier and whiter teeth is all that people wanted. To get whiter and shiny teeth people use many home remedies, but what works better, in-office or home treatment."
    }, {
        id: "blog-137",
        slug: "what-to-do-if-permanent-teeth-becomes-loose",
        title: "Loose Permanent Tooth - Solution For The Problem",
        description: "If you encounter any of your tooth being loose, that shows you may have some dental problems such as gum disease, tooth decay, etc. Get the solution by reading the article."
    }, {
        id: "blog-138",
        slug: "what-is-bonding-difference-between-bonding-and-veneers",
        title: "What Is The Difference Between Bonding And Veneers?",
        description: "Dental Bonding and Dental Veneers are two different cosmetic procedures, which are used to acquire the same result and are often confused with each other."
    }, {
        id: "blog-139",
        slug: "understanding-and-prevention-of-dry-socket-after-tooth-extraction",
        title: "Dry Socket After Tooth Extraction: Understanding And Aftercare",
        description: "Dry socket is very painful complication caused after the tooth extraction. Here are few ways with which you can take care of your dry socket, read more."
    }, {
        id: "blog-140",
        slug: "what-are-the-bruxism-symptoms-causes-and-treatment/",
        title: "What is Bruxism : Symptoms, Causes And Treatment",
        description: "Bruxism is a condition in which you grind or crunch your teeth which may lead to tooth damage. Know the symptoms, causes and treatment for Bruxism. Read more..."
    }, {
        id: "blog-141",
        slug: "what-are-the-latest-dental-implant-technologies",
        title: "Know What Are The Latest Dental Implant Technologies?",
        description: "Learn about the latest dental implant technologies which have a big impact on the effectiveness of dental professionals and lead to better dental outcomes."
    }, {
        id: "blog-142",
        slug: "overcoming-your-fear-of-the-dentist",
        title: "Overcome Your Fear To Visit A Dentist",
        description: "Are you afraid for visiting a dentist? Here are some factors which can help you to overcome your fear of visiting a dentist. Read more to know more.."
    }, {
        id: "blog-142",
        slug: "debunking-the-5-most-common",
        title: "Debunking The 5 Most Common Dental Care Myths | Infographic",
        description: "There are so many dental myths that people think are true. Here are the top five most common dental care myths which you must know. Click to know more."
    },

    // page 13

    {
        id: "blog-143",
        slug: "know-the-signs-and-symptoms-of-teeth-filling",
        title: "Know The Signs And Symptoms Of Teeth Filling - Carrumdownsdental",
        description: "When your tooth decay gets larger you may observe some signs and symptoms such as a toothache, broken or lost filling, sensitivity, dark spot or hole in the tooth, this is the time when you need teeth filling. Know the procedure and how to take care of dental filling."
    },
    {
        id: "blog-144",
        slug: "best-solution-for-whiter-teeth",
        title: "Porcelain Dental Veneers | Types, Procedure & Benefits",
        description: "Dental veneers are the best solution for whiter teeth and helps to recover the gaps in the tooth and misshaped teeth occurrence. Know the types of porcelain veneers, procedure on how it is performed and the benefits of veneers."
    }, {
        id: "blog-145",
        slug: "keep-your-teeth-and-gums-healthy",
        title: "Natural Dental Care To Keep Your Gums And Teeth Healthy",
        description: "Prevention is better than cure, for this you should take care of your teeth and gums before it becomes a huge problem. Here are some natural dental health care tips you can follow to get healthy gums and teeth."
    }, {
        id: "blog-146",
        slug: "right-way-to-keep-your-teeth-clean",
        title: "Keep Your Teeth Clean With Cosmetic Dentistry - Carrumdownsdental",
        description: "Cosmetic dentistry focus on improving the appearance of your smile, there is a broad range of cosmetic treatment such as teeth whitening, veneers, teeth cleaning, implants etc. From all this teeth cleaning is a common treatment. Know how the complete procedure is performed."
    }, {
        id: "blog-147",
        slug: "trusted-dental-clinic",
        title: "Trusted Dental Clinic - Carrum Downs Dental Group",
        description: "We have a team of a highly skilled dentist who can provide comprehensive dental treatment to their patients. You can also book your appointment online, we have a 24-hour cancellation policy so don't hesitate to book your appointment, you'll get the best treatment from us."
    }, {
        id: "blog-148",
        slug: "when-should-you-have-a-tooth-extracted",
        title: "When Should You Need A Tooth Extracted ?",
        description: "An extraction means to have a tooth removed, usually tooth extraction is the last option by the dentists. A tooth need to be extracted because of some issues like Trauma, Impaction, Infection, Gum Diseases and many more."
    }, {
        id: "blog-149",
        slug: "why-is-paediatric-dentistry-important",
        title: "The Importance Of Pediatric Dentistry | Children’s Dentistry",
        description: "Children need attention towards their oral health from the very early time. Pediatric dentists also recommend to take care of children’s teeth from infancy. Know the reasons why pediatric dentistry is important."
    }, {
        id: "blog-150",
        slug: "denture-treatment-restore-your-smile",
        title: "Denture Treatment – Types And Procedures",
        description: "The denture is used for replacing the missing teeth, it restores your smile and confidence. There are different types of denture such as complete denture, partial denture etc. Denture is a removable replacement of missing teeth and it also improves speech problem."
    }, {
        id: "blog-151",
        slug: "be-aware-of-threats-to-dental-health",
        title: "Threats To Dental Health – Carrum Downs Dental Group",
        description: "Many people are not aware about the threats to dental health. There are many adverse effects of neglecting the oral health like heart disease, diabetes, tooth decay and many more. Learn more about the dental health threats."
    }, {
        id: "blog-152",
        slug: "types-of-cosmetic-dentistry-procedures",
        title: "Types of Cosmetic Dentistry – Improve Your Smile",
        description: "Everyone wants a pleasing smile, to improve the appearance of your smile, cosmetic dentistry is the option. Different types of cosmetic dentistry is available with Carrum Downs Dental Group such as root canal, dental implant, veneers, teeth whitening etc."
    }, {
        id: "blog-153",
        slug: "the-dos-and-donts-of-denture",
        title: "Do’s And Don’ts Of Denture – Carrum Downs Dental Group",
        description: "Here are some do’s and don’ts for denture care. Don’t sleep with a denture, when not in use take out your denture and soak in water to keep it moist. It’s important to wash your denture daily after your meal. Read more."
    },{
        id: "blog-154",
        slug: "what-teeth-tell",
        title: "What Teeth Tell Us – Carrum Downs Dental Group",
        description: "Teeth are like fingerprints, every set is unique. Know what our teeth tell us from the age, habits and condition of teeth."
    }, 
    
    // page 14
    
    {   
        id: "blog-155",
        slug: "choose-cerec",
        title: "Choose Cerec – Restore Damaged Teeth",
        description: "For the restoration of your teeth choose cerec treatment, as it may restore shape size and appearance. It is an advanced technology which will give you a natural looking smile and restores damaged teeth."
    }, {
        id: "blog-156",
        slug: "gentle-dental-tips-for-pain-free-dentist-visits",
        title: "Gentle Dental Care | Sedation Dentistry - Pain Free Dentist Visit",
        description: "No need to fear of visiting the dentist as gentle dental is the latest style used by the dentists for a pain free treatment. Different dental related procedures are involved in gentle dental which will help for a pain free dentist visit."
    }, {
        id: "blog-157",
        slug: "how-to-preserve-strong-dental-health-for-children",
        title: "Ways To Preserve Your Child's Dental Health",
        description: "It's important to preserve your child's dental health, for this parents should adopt some measures that will aim to improve their child's dental health."
    }, {
        id: "blog-158",
        slug: "inlay-and-onlay-procedure",
        title: "Procedures Of Inlay and Onlay - Carrum Downs Dental Group",
        description: "For restoring a damaged and decayed tooth to its original condition and strengthen its functionality, dental inlay and onlay procedure is used."
    }, {
        id: "blog-159",
        slug: "is-thumb-sucking-bad-for-my-childs-teeth",
        title: "Know The Pros And Cons Of Thumb Sucking For Your Child",
        description: "Thumb sucking have some benefits, but it may have certain consequences for your child's health in future, it may also lead to tooth decay."
    },{
        id: "blog-160",
        slug: "fun-facts-about-teeth",
        title: "Interesting Facts And Fun About Teeth - Carrum Downs Dental Group",
        description: "Looking for fun facts about your teeth? Here are some awesome fun facts which will amaze you. Have a look at this infographic!"
    },{
        id: "blog-161",
        slug: "how-to-care-for-your-teeth-when-pregnant",
        title: "Dental Care: Before, During And After Pregnancy",
        description: "Know what should you do to take care of your teeth during pregnancy. Taking care of your teeth is good for your health and your baby's health too. Have a look at this infographic to enhance your knowledge."
    },{
        id: "blog-162",
        slug: "periodontitis-disease-treatment",
        title: "Know more about Periodontitis Gum Disease and Its Treatment",
        description: "Want to know more about Periodontitis? Here it is, When a long time has gone in-between dental checkups, sometimes harmful bacteria and hard tartar builds up on your teeth and over the gum line, that releases toxins causing gum disease known as “Periodontitis”. Check out this video for more details."
    },{
        id: "blog-163",
        slug: "what-teeth-tell-us",
        title: "Teeth Tell Us: Age, Habits, Condition and Disease",
        description: "Teeth are just like fingerprints. Every fingerprint is unique and our teeth are also unique. Teeth tell us the things which we can’t understand. To know what teeth tell us, check this infographic."
    },{
        id: "blog-164",
        slug: "teeth-grinding-from-causes-to-treatments",
        title: "Teeth Grinding Causes and Treatments | Carrum Downs Dental Group",
        description: "The infographics will tell you what the symptoms of teeth grinding are and what are the solutions to reduce these problems along with the treatment."
    },{
         id: "blog-155",
         slug: "things-you-need-to-know-dental-care-for-children",
         title: "Dental Care for Children| Paediatric Dentist | Carrum Downs Dental",
         description: "The importance of dental care for children is as important as overall health. Dental health for kids should start as soon as their first teeth erupt. From that time onwards, proper dental hygiene and regular visits to the dentist will play a vital role in your child’s dental health."
     },{
         id: "blog-166",
         slug: "healthy-teeth-for-children-is-the-key-to-future-dental-health",
         title: "These Ultimate Tips Will Protect Your Child's Dental Health Future",
         description: "Healthy eating habits are very essential for your children’s dental health. Most of the teeth cavities in the child's teeth result from poor feeding habits. Dental care should start even before your child’s first tooth grows in. Go through the below information for all your child’s dental need."
     }, 
     // page 15
    
    {   
        id: "blog-167",
        slug: "medicare-what-dental-services-are-covered-in-medicare",
        title: "Types Of Dental Services Covered In Medicare",
        description: "Medicare is a government program and its main aim is to help people from low family income access affordable health care. This program does not cover everything. The only Medicare program known as Child Dental Benefits Schedule (CDBS) under Medicare is available at Carrum Downs Dental Group."
    }, {
        id: "blog-168",
        slug: "dental-coverage-benefits-under-medicare",
        title: "Dental Coverage Benefits Under Medicare | Carrum Downs Dental Group",
        description: "Dental care should be part of healthy lifestyle. A majority of people, especially from low-income earning families, has long complained that the cost of dental services is very high for them. We have Medicare facility at Carrum Downs Dental Group who will take care of your teeth."
    }, {
        id: "blog-169",
        slug: "the-facts-vs-the-fake-the-true-benefits-of-natural-teeth-whitening",
        title: "Teeth Whitening | Carrum Downs Dental Care",
        description: "Dental provides excellent services for teeth whitening in Carrum Downs Dental Care. A bright white smile helps in both personal and professional pursuits."
    }, {
        id: "blog-170",
        slug: "5-most-common-dental-emergencies-and-how-to-deal-with-them",
        title: "Handling With Dental Emergencies | Carrum Downs Dental Care",
        description: "Any dental emergency like bleeding gums or cavities to the teeth can be serious if ignored. Ignoring a dental problem can increase the risk of permanent damage."
    }, {
        id: "blog-171",
        slug: "what-to-do-in-dental-emergency",
        title: "Emergency Dentist At Carrum Downs Dental Care",
        description: "If you are facing a problem on a holiday, weekend, or in the middle of the night? then your dentist should be your first call. You need an emergency dentist."
    }, {
        id: "blog-172",
        slug: "dental-crowns-and-bridges-a-look-at-cosmetic-dentistry",
        title: "Crowns & Bridges | Cosmetic Dentistry in Carrum Downs VIC",
        description: "Dental crowns and bridges are commonly used to replace teeth that are missing, cracked, crooked or decayed. Both are used to fill the gap between teeth."
    }, {
        id: "blog-173",
        slug: "5-tips-for-taking-your-child",
        title: "Pediatric Dentistry | Carrum Downs Dental Care",
        description: "The dental health of children is known as Pediatric Dentistry. You should teach your children that the dentist is important for them."
    },{
        id: "blog-174",
        slug: "what-are-the-consequences-of-delaying-a-root-canal",
        title: "What Are The Risks and Consequences of Delaying a Root Canal?",
        description: "Delaying a root canal can actually put you at greater risk, including losing your tooth. Learn more about the consequences of delaying a root canal."
    }, {
        id: "blog-175",
        slug: "what-happens-when-you-get-a-dental-filling",
        title: "Dental Filling: What Happens When You Get It Done | Carrum Downs",
        description: "If you have a cavity, you will need to visit the dentist for a filling. Learn about dental filling & a step-by-step procedure of what happens when you get a filling."
    }, {
        id: "blog-176",
        slug: "how-to-pick-the-right-dental-implant-provider-in-australia",
        title: "How To Choose The Right Dental Implant Provider in Australia?",
        description: "Whether you are missing one tooth or all of your teeth, we can provide the treatment that best suits your needs. Find the right provider that fits your needs. Call us now!"
    }, {
        id: "blog-177",
        slug: "5-things-to-expect-when-getting-a-denture",
        title: "Five Things You Must Know Before You Get Your First Denture",
        description: "Got your first dentures? Find out what you should expect when being fitted for your first denture. Call Carrum Downs Dental Clinic and schedule a dental appointment today."
    }, {
        id: "blog-178",
        slug: "do-you-have-clean-teeth",
        title: "Tips for Keeping Your Teeth White and Healthy",
        description: "Learn how to keep your teeth clean, including advice on toothbrushes, toothpaste, floss and get expert tips and advice on how to maintain healthy teeth and gums. Call now!"
    },

    // page 16

    {
        id: "blog-179",
        slug: "what-you-need-to-know-about-teeth-cleaning",
        title: "All You Need to Know About Teeth Cleaning",
        description: "Are you on the fence about getting professional teeth cleaning? Learn what you need to know about teeth cleaning at Carrum Downs Dental Group. Contact today for more details!"
    },{
        id: "blog-180",
        slug: "effective-ways-to-care-for-your-veneers",
        title: "Expert Tips to Take Care of Your Dental Veneers",
        description: "You must care for your veneers just as much as you care for your real teeth. Find here, some expert tips to take care of dental veneers & follow them to maintain good dental hygiene."
    },{
        id: "blog-181",
        slug: "how-to-take-care-of-your-gums",
        title: "How to Keep Your Gums & Teeth Healthy - Carrum Downs Dental Group",
        description: "Proper oral health begins with healthy gums. To keep your gums and teeth strong and healthy, check out these best tips on how to keep your gums healthy. Call us for more!"
    },{
        id: "blog-182",
        slug: "what-to-look-for-in-a-family-dentist",
        title: "4 Factors When Choosing a Family Dentist That's Right for You",
        description: "Looking for a professional family dentist? Here's a checklist of what you should look for in a family dentist. We provide excellent dental care for the whole family. Call us today!"
    },{
        id: "blog-183",
        slug: "easy-and-effective-ways-for-natural-teeth-whitening",
        title: "7 Easy and Effective Ways to Naturally Whiten Your Teeth",
        description: "We at Carrum Downs Dental Clinic can't wait to share with you 7 super effective ways to naturally whiten your teeth. Read out these effective tips on natural teeth whitening."
    },{
        id: "blog-184",
        slug: "dental-treatments-for-top-10-mouth-problems",
        title: "Dental Treatments for Top 10 Mouth Problems",
        description: "Here are some common & serious Mouth Problems caused by bad oral health. Below is a list of 10 of the most common dental problems & the best ways to treat them. Read more."
    },{
        id: "blog-185",
        slug: "single-tooth-implants-can-give-you-back-your-smile",
        title: "Bring Back Your Smile with Dental Implants in Carrum Downs",
        description: "If you are missing one or more teeth,dental implants can be your permanent smile solution. We provide a complete solution with our new dental implant procedures!"
    },{
        id: "blog-186",
        slug: "do-floss-and-fluoride-prevent-tooth-decay-and-gum-disease",
        title: "Do Floss and Fluoride Really Prevent Tooth Decay and Gum Disease?",
        description: "A simple routine can help prevent most dental problems. To learn more about how you can prevent tooth decay & gum disease with preventive dentistry, Call Today!"
    },{
        id: "blog-187",
        slug: "facts-you-need-to-know-about-wisdom-tooth-extraction",
        title: "Important Facts You Need To Know About Wisdom Tooth Extraction",
        description: "Whether your molars are just showing up or about to get removed, here's everything you need to know before you go in for surgery. A few quick facts for you."
    },{
        id: "blog-188",
        slug: "new-years-dental-resolutions-2018",
        title: "Dental New Year's Resolution for 2018 | Carrum Downs Dental Group",
        description: "Are you ready to ring in 2018 with a super smile? By including these 6 resolutions into your oral care routine,you can have a beautiful smile for 2018 & beyond."
    },{
        id: "blog-189",
        slug: "a-patients-guide-to-root-canals",
        title: "A Dental Patient's Guide To Root Canals - Dental Infographic",
        description: "Do you need Root Canal? Find out why, its signs and treatment procedure in this Root Canal Infographic. For better treatment visit Carrum Downs Dental Clinic."
    },{
        id: "blog-190",
        slug: "advantages-of-dental-bridges",
        title: "Types And Advantages of Dental Bridges | Dental Infographic",
        description: "This Infographic will show you the types and general advantages of Dental Bridges. To restore a missing tooth visit Carrum Downs Denta Group. Book Online Appointment."
    },

    // page 17

    {
        id: "blog-191",
        slug: "crowns-the-kings-of-restorative-dentistry",
        title: "Restorative Dentistry Is The Repair And Restoration Of Teeth.",
        description: "At some point, almost everyone needs some type of restorative dentistry to repair, rebuild or replace a tooth. Restore your tooth from Carrum Downs Dental Dentist."
    },{
        id: "blog-192",
        slug: "which-is-right-for-you-at-home-or-professional-teeth-whitening",
        title: "Home vs. Professional Teeth Whitening | Carrum Downs Dental Group",
        description: "Compare the pros and cons of teeth whitening vs. professional teeth whitening. White teeth have long been considered as a sign of beauty and health."
    },{
        id: "blog-193",
        slug: "you-know-poor-nutrition-can-affect-your-teeth",
        title: "Poor Nutrition Can Affect Your Teeth | Carrum Downs Dental Group",
        description: "A well-balanced diet helps in keeping your teeth and gums healthy. Brush and floss on a daily basis drink lots of water and visit the dentist regularly."
    },{
        id: "blog-194",
        slug: "to-avoid-gum-disease-its-important-to-keep-up-with-dental-cleanings",
        title: "Keep Up With Dental Cleanings And Avoid Gum Disease",
        description: "It is important to keep them clean and free from plaque-laden bacteria that could cause severe, irreversible damage. Read this article to Keep Your Gums Healthy."
    },{
        id: "blog-195",
        slug: "how-you-can-use-your-dental-insurance-before-this-year",
        title: "Use Your Dental Insurance By the End of Year Before at Carrum Downs Dental",
        description: "As the year comes to a close, you should focus on using your dental insurance plans before it runs out. Read about why you should use your dental insurance."
    },{
        id: "blog-196",
        slug: "all-you-need-to-know-about-tooth-aligners",
        title: "Everything You Need To Know About Tooth Aligners",
        description: "What you should know about tooth-straightening aligners if you are considering any orthodontic treatment it is worth your time to be diagnosed by Carrum Downs Dentist."
    },{
        id: "blog-197",
        slug: "porcelain-veneers",
        title: "All You Need To Know About Porcelain Veneers | Dental Infographic",
        description: "Dentists at Carrum Downs Dental Group perform porcelain veneers that make your teeth whiter, straighter and more aligned. Learn more about veneers on our blog."
    },{
        id: "blog-198",
        slug: "wisdom-teeth-removal-infographics",
        title: "All About Wisdom Tooth And After Care | Dental Infographic",
        description: "Wisdom tooth removal can be carried out by a dentist or a specialist surgeon. Get the best treatment for Wisdom tooth extraction from expert dentist in Carru Downs."
    },{
        id: "blog-199",
        slug: "the-importance-of-replacing-teeth-dental-implants",
        title: "Benefits Of Removing Teeth | Importance Of Dental Implant",
        description: "Everything you need to know about dental implants, including answers to your questions about dental implants and dental implant dentists. Read on our blog."
    },{
        id: "blog-200",
        slug: "pros-and-cons-of-veneers",
        title: "Dental Veneers Are Thin Pieces Of Tooth Colored Porcelain",
        description: "Dental veneers are an excellent way to hide discolored, crooked or damaged teeth, but it's important to weigh the pros and cons that come. Read more on our blog."
    },{
        id: "blog-201",
        slug: "dental-coverage-under-medicare-by-carrum-downs",
        title: "Dental Coverage Under Medicare | Carrum Downs Dentist",
        description: "Medicare is a federal health insurance program that covers various health care bills. Learn more about the benefits of the Dental Coverage Under Medicare."
    },{
        id: "blog-202",
        slug: "dental-bonding-vs-dental-crowns",
        title: "Differences Between Dental Bonding and Crowns | Carrum Downs Dentist",
        description: "This article focuses on two options which can be applied in such a scenario dental bonding and dental crowns. Visit our clinic for ultimate Tooth Restoration."
    },
    
    //page 18
    
    {
        id: "blog-203",
        slug: "tips-on-how-to-whiten-teeth-and-keep-them-white",
        title: "How You Can Work Toward Whitening Your Teeth | Carrum Donws Dentist",
        description: "Whitening the teeth are usually associated with healthy teeth to protect your teeth and gums from diseases, it is advisable to visit the dentist regularly."
    },{
        id: "blog-204",
        slug: "ways-to-care-for-both-temporary-and-permanent-dental-crowns",
        title: "How to care for Temporary and Permanent Dental Crowns",
        description: "Find out the ways to care for both temporary and permanent dental crowns by Carrum Downs Dental Dentists. For more information and dental care visit our clinic."
    },{
        id: "blog-205",
        slug: "dental-bridges",
        title: "Types & Advantages Of Dental Bridges | Dental Infographic",
        description: "Dental bridges literally bridge the gap created by one or more missing teeth. Learn more here about the Dental Bridges Types & Advantages. Visit our clinic!"
    },{
        id: "blog-206",
        slug: "wisdom-tooth-extraction",
        title: "Your Survival Guide To Wisdom Tooth Extraction | Infographic",
        description: "We have an infographic for Wisdom Teeth Removal Survival Guide with tips and instructions on what to expect and how to handle this often painful time. Learn more!"
    },{
        id: "blog-207",
        slug: "teeth-whitening-methods-and-aftercare",
        title: "Find Out The Aftercare of Teeth whitening | Carrum Downs Dentist",
        description: "Teeth Whitening Aftercare methods and tips. Get Carrum Downs Dental expert answers about Teeth Whitening and Aftercare from Doctors."
    },{
        id: "blog-208",
        slug: "how-long-does-a-dental-implant-procedure-take",
        title: "How Long Does A Dental Implant Procedure Take? | Carrum Downs Dentist",
        description: "Find out how long does it take to get a Dental Implant surgery to replacement teeth in Carrum Downs Dental Group Blog. Read more dental related articles."
    },{
        id: "blog-209",
        slug: "root-canal-faqs",
        title: "Root Canal - FAQs | Carrum Downs Dental Group",
        description: "Frequently Asked Questions About Root Canal Treatment. Learn about root canals, finding an endodontist, saving teeth and reducing pain. Get all answers here."
    },{
        id: "blog-210",
        slug: "what-is-the-appropriate-age-to-take-a-child-to-their-first-dentist-visit",
        title: "Right Age To Take Your Child to a Dentist for the First Time",
        description: "The first visit should be when the first tooth erupts in the mouth, no later than age one to two. Read our blog and prepare your child’s first dental visit."
    },{
        id: "blog-211",
        slug: "top-5-most-common-cosmetic-dentistry-procedures",
        title: "Top Cosmetic Dentistry Procedure For Your Beautiful Smile",
        description: "Make your smile even more beautiful, this guide will show top 5 Cosmetic Dentistry Treatments. Teeth Whitening, Porcelain Veneers, Crowns, Dental Bonding & Dental Bridges"
    },{
        id: "blog-212",
        slug: "what-to-do-in-a-dental-emergency",
        title: "How To Handle Dental Emergency | Carrum Downs Dental Group",
        description: "Check out the following examples for handling dental emergencies. Learn how to treat common dental emergencies, like cracked or broken teeth from Carrum Downs Dentists."
    },{
        id: "blog-213",
        slug: "how-dentist-in-carrum-downs-can-fix-dental-dark-spots-stains-dis-colourations",
        title: "How Dentist Can Fix Dental Dark Spots, Stains & Dis-Colourations",
        description: "Find out the ways to get rid of dark spots, stains & dis-colorations on Teeth. Dentist of Carrum Downs can fix dental dark spots, stains, & discoloration. Read our blog."
    },{
        id: "blog-214",
        slug: "dont-forget-your-dental-exams-cleanings",
        title: "Schedule Your Dental Exams & Cleanings At Carrum Downs Dentist",
        description: "Do not forget to schedule your dental cleaning exam & any other dental procedures as soon as possible. Carrum Downs Dental Group has experienced Dentists in town."
    },

    // page 19

    {
        id: "blog-215",
        slug: "how-can-dental-implants-change-your-life",
        title: "Everything You Need To Know About Dental Implants",
        description: "Dental Implants that changes your life. Carrum Downs Dentist explains numerous benefits of Dental Implant. We provide high-quality service at affordable price."
    }, {
        id: "blog-216",
        slug: "tips-to-help-your-kids-overcome-dental-fears",
        title: "How You Can Help Your Kids Overcome Dental Fears",
        description: "Carrum Downs Dentist gives you some essential information on dental fear and tips on how to help your kids overcome from dental fear. Take your child to our Dentist!"
    }, {
        id: "blog-217",
        slug: "what-is-a-dental-emergency",
        title: "Get All Information About Dental Emergency With Infographic",
        description: "Dental Emergency is a dental problem that requires immediate treatment in order to save a tooth or alleviate severe pain is considered a dental emergency."
    }, {
        id: "blog-218",
        slug: "improving-your-smile-through-cosmetic-dentistry",
        title: "Cosmetic Dentistry Infographic - Improving Your Smile",
        description: "Improving your smile through Cosmetic Dentistry. Carrum Downs Dentists are experienced in Cosmetic Dentistry. Book your online appointment today with Carrum Downs Dentist."
    }, {
        id: "blog-219",
        slug: "6-reasons-to-smile-about-dental-implants",
        title: "Now You Have 6 Reasons To Smile With Dental Implants",
        description: "Learn more benefits of dental implants. Here are some tips from Carrum Downs Dental Group for people who are missing teeth. 6 Reasons to Choose Dental Implants."
    }, {
        id: "blog-220",
        slug: "all-you-need-to-know-about-dentures",
        title: "These Are Most Important Things To Know About Dentures",
        description: "There are many things you need to know before getting dentures. These things will guide you and you will know about Dentures. Read more about Dentures at our Blog."
    }, {
        id: "blog-221",
        slug: "all-you-need-to-know-about-dental-emergencies",
        title: "Understand Dental Emergencies | How To Handle Dental Emergencies?",
        description: "All you need to know about dental emergencies. Here is quick summary from Carrum Downs Dentist of what to do for some common dental emergencies. To know more call us!"
    }, {
        id: "blog-222",
        slug: "the-right-way-to-brush-carrum-downs-dental-group",
        title: "Know The Right Way to Brush Your Teeth From Carrum Downs Dentist",
        description: "Learn how to brush your teeth the right way and you'll protect them for years to come. Check out this Video and learn the right way to brush your teeth."
    }, {
        id: "blog-223",
        slug: "7-steps-to-brushing-your-teeth-with-braces-on",
        title: "7 Steps to Brushing Your Teeth With Braces On | Infographic",
        description: "A person with braces should brush each day. Taking care of teeth with braces requires diligence check out these steps how to brush their teeth with braces."
    }, {
        id: "blog-224",
        slug: "root-canal-therapy-inside-out",
        title: "How To Save Your Tooth By Root Canal Therapy | Carrum Downs Blog",
        description: "Root canal procedure is advantageous in so many ways. Know How To Save Your Tooth By Root Canal Therapy from Carrum Downs Dentist located in Carrum Downs & nearby suburbs"
    }, {
        id: "blog-225",
        slug: "tooth-extraction-all-you-need-to-know",
        title: "What You Need to Know About Tooth Extraction by Carrum Downs Dentist",
        description: "Everything You Need to Know Tooth Extraction, Types, Procedure and After Tooth Removal. Carrum Downs Dentists are experienced in handling Tooth Extraction Treatment."
    }, {
        id: "blog-226",
        slug: "why-do-we-have-wisdom-teeth-issues-and-solutions",
        title: "Find Out The Solution Why Do We Need To Remove Wisdom Teeth.",
        description: "Get a closer look behind the wisdom teeth. Find out the Wisdom Teeth Issues & Solutions which will help you to understand all about Wisdom Tooth pain and its treatment."
    },

    // page 20

     {
        id: "blog-227",
        slug: "what-is-root-canal-treatment",
        title: "What is Root Canal Treatment? | Carrum Downs Dental Blog",
        description: "RC procedure that involves removing a tooth with dead or an infected pulp, disinfect and sealing the root canal to prevent the spread of infection or damage."
    }, {
        id: "blog-228",
        slug: "7-steps-to-a-better-smile",
        title: "7 Steps to a Better Smile | Carrum Downs Dental Blog",
        description: "Our dentists are well-trained and experienced in dealing with different dental problems. Visit us today for a brighter and attractive smile."
    }, {
        id: "blog-229",
        slug: "service-provided-by-our-dentists",
        title: "Dental Treatments Provided by Carrum Downs Dental Group Dentist",
        description: "Carrum Downs Dental Group provides the affordable & highest quality dental care. All Our Services are available in and around Carrum Downs and nearby suburbs."
    }, {
        id: "blog-230",
        slug: "tooth-replacement-options-dental-implants-bridges-and-dentures",
        title: "What are Tooth Replacement Options | Carrum Downs Dental Blog",
        description: "Some of these tooth replacement methods include dental implants, bridges, and dentures. Know what are the advantages and procedure by Carrum Downs Dental Group"
    }, {
        id: "blog-231",
        slug: "what-crowns-and-veneers-can-do",
        title: "Crowns and veneers can effectively change your smile",
        description: "Are you unsure about crowns and veneers? Well, the simplest way to find out what is best for you is to consult a dentist. Book an appointment!"
    }, {
        id: "blog-232",
        slug: "top-5-common-myths-and-facts-of-dental-implants",
        title: "Top 5 Common Myths and Facts of Dental Implants",
        description: "Here are some common myths and facts of dental implants. Carrum Downs Dental Group, are experts at restoring dental implants, and an ideal choice for patients."
    }, {
        id: "blog-233",
        slug: "what-to-expect-during-dental-implant-treatment",
        title: "Expectation During Dental Implant Treatment | Carrum Downs Dental Blog",
        description: "Generally dental implants can treat all form of teeth loss but there some instances where other methods may be favorable. Read more from Dentist of Carrum Downs"
    }, {
        id: "blog-234",
        slug: "dental-implants-procedure",
        title: "A Comprehensive Review for Dental Implant by Carrum Downs Dental Group",
        description: "When it comes to tooth replacement, the patient has two methods to choose from. Know all about Dental Implant from Carrum Downs Dentists."
    }, {
        id: "blog-235",
        slug: "all-you-need-to-know-about-denture-repairs",
        title: "All You Need to Know About Denture Repairs | Carrum Downs Dental",
        description: "Denture repair is a fix of the denture itself, part of it or the framework. Although there are many different types of denture repair, click to learn more."
    }, {
        id: "blog-236",
        slug: "carrum-downs-dental-group-is-now-a-partner-of-smile-com-au",
        title: "Carrum Downs Dental Group Partnered with Smile.com.au",
        description: "Make your dental health a priority and join smile.com.au & start receiving affordable dental treatment. Quality dental treatments, now at great prices - Carrum Downs Dental"
    },{
        id: "blog-237",
        slug: "are-you-prepared-for-handling-a-dental-emergency",
        title: "How To Be Prepared For Handling A Dental Emergency?",
        description: "Any medical emergency, a dental- emergency can happen anytime and without any warning. These are the some tips from Carrum Downs Dental Group to Handle Dental Emergency."
    },

    // page 21

    {
        id: "blog-238",
        slug: "the-benefits-of-calcium-for-your-healthy-teeth",
        title: "Explore The Benefits of Calcium for Your Healthy Teeth",
        description: "A majority of people around the globe consume food that is low in calcium. Know the Benefits of Calcium for Healthy Teeth by Carrum Downs Dental Group Dentist"
    }, {
        id: "blog-239",
        slug: "how-to-care-for-your-babys-emerging-teeth-and-gums",
        title: "How To Care For Your Baby's Emerging Teeth and Gums",
        description: "Here are some simple, practical tips on how to provide your baby’s new teeth with proper care. For more info contact Carrum Downs Dental Group"
    }, {
        id: "blog-240",
        slug: "how-smoking-effects-on-your-oral-health",
        title: "Here's How Smoking Effects on Your Oral Health - Carrum Downs Dental",
        description: "We have helped many customers deal with tooth issues and gum diseases caused by smoking; we want to help you too. Visit us today or leave us a note."
    }, {
        id: "blog-241",
        slug: "top-5-simple-tips-for-proper-denture-care-for-new-denture-patients",
        title: "Top 5 Tips For Proper Denture Care For New Denture Patients",
        description: "Dentures help you keep your appearance and maintain that beautiful smile after you lose your teeth. Call at Carrum Downs Dental Group for more info."
    }, {
        id: "blog-242",
        slug: "how-you-can-get-a-natural-look-with-dental-crowns-and-bridges",
        title: "What are Dental Crowns & Bridges and How one get a Natural Look?",
        description: "If you have missing teeth it’s unlikely that you will want to smile. Carrum Downs Dental will restore your confidence and have you smiling again."
    }, {
        id: "blog-243",
        slug: "fillings-options",
        title: "Dental Fillings at Carrum Downs Dental Group | Blog",
        description: "Whenever a person faces a dental cavity or broken tooth problem, an important decision must be taken. Here are some alternatives that include dental fillings."
    }, {
        id: "blog-244",
        slug: "cdbs-expected-to-close-by-the-end-of-the-year",
        title: "CDBS expected to close by the end of the year | Blog",
        description: "It is increasingly likely that the Child Dental Benefits Schedule will close on 31 December this year. Read Carrum Downs Dental Group blog for more details.."
    }, {
        id: "blog-245",
        slug: "prevention-is-better-than-cure-dental-hygiene",
        title: "7 Essential Tips to Prevent Dental Problems",
        description: "When it comes to dental hygiene and oral health we believe prevention is better than cure. Know what preventive measures you need to take for good oral health."
    }, {
        id: "blog-246",
        slug: "what-you-should-do-to-eliminate-tooth-decay-fast",
        title: "Tips To Eliminate Tooth Decaying",
        description: "Good dental care and oral hygiene can help you avoid tooth decaying. Check out some important tips to eliminate tooth decay problems."
    },{
        id: "blog-247",
        slug: "5-essential-tips-for-complete-dental-care",
        title: "5 Important Tips to Follow for Complete Dental Care",
        description: "Proper dental care and oral hygiene is extremely important to have healthy teeth and gums. Here are 5 must follow tips for complete dental care."
    },{
        id: "blog-248",
        slug: "5-best-dental-care-tips-for-kids",
        title: "Are You Following These Dental Care Tips for Your Kids?",
        description: "Teaching your children good dental habits can lead to healthy teeth and pleasant smile. Follow these tips to keep your child’s teeth clean and prevent cavities"
    }, {
        
        id: "blog-249",
        slug: "important-tips-to-adopt-good-dental-care-habits",
        title: "Why Should You Adopt Good Dental Care Habits?",
        description: "Taking care of your teeth helps you maintain your dental health and prevent dental problems. For healthy teeth you need to follow some good dental care habits."
    }, 
    
    // page 22

    {
        id: "blog-250",
        slug: "why-six-month-dental-check-up-and-cleaning-is-very-important",
        title: "Why Regular Dental Checkup is Important – Carrum Downs Dental Group",
        description: "Regular dental checkup is extremely important to keep your teeth and gums healthy and strong. You must visit your dentist every six months."
    }, {
        id: "blog-251",
        slug: "childrens-dental-advice",
        title: "Dental Advice for Children – Carrum Downs Dental Group",
        description: "Teaching your kids good dental habits and oral hygiene can lead to healthy teeth and a healthy smile. Check out some important kid’s dental tips and advice."
    }, {
        id: "blog-252",
        slug: "dental-emergency-visit-your-dentist-now",
        title: "Dental Emergency | Carrum Downs Dental Group",
        description: "Do you have a dental emergency? Do not ignore it. Seek the treatment for your dental problem urgently. Visit our clinic at Carrum Downs today!"
    }, {
        id: "blog-253",
        slug: "vouchers",
        title: "Vouchers @ Carrum Downs Dental Group",
        description: "Carrum Downs Dental Group provides various vouchers for your dental treatment. Get to know the types of vouchers and all its details here."
    }, {
        id: "blog-254",
        slug: "child-dental-benefits-schedule-continues-to-operate",
        title: "CDBS Continues to Operate | Carrum Downs Dental Group",
        description: "Child Dental Benefits Schedule (CDBS) that provide various dental services remains open as the legislation was not passed by the Parliament. Read more here."
    }, {
        id: "blog-255",
        slug: "carrum-downs-dental-clinic-is-now-a-cbhs-choice-network-provider",
        title: "Carrum Downs Dental is Now a CBHS Choice Network Provider",
        description: "Carrum Downs Dental Clinic is pleased to announce its participation in the CBHS choice network provider coverage. Contact us for more details."
    }, {
        id: "blog-256",
        slug: "canal-dental-root-canal-things-you-need-to-know-before-seeing-a-dentist",
        title: "Things You Need to Know Before Seeing A Dentist for Root Canal",
        description: "If you are experiencing tooth pain, don’t suffer alone in silence! Root canal procedure is done at a very affordable rate at Carrum Downs Dental Group."
    },{
        id: "blog-257",
        slug: "five-reasons-why-you-should-consider-sedation-dentistry",
        title: "Five Reasons Why You Should Consider Sedation Dentistry | Dental Blogs",
        description: "Don't Avoid getting your dental care because of the anxiety of going to the dentist. Come to Carrum Downs Dental and talk to our dentists about sedation dentistry."
    },
    {
        id: "blog-258",
        slug: "procedure-for-wisdom-tooth-extraction",
        title: "Procedure for Wisdom Tooth Extraction",
        description: "Wisdom teeth are the third molars on both the upper and lower jaws. They are located at the very back of the mouth, and they are usually the last to emerge. They are called wisdom teeth"
    }

];

export default seo